// @flow
import { useCallback, useRef, useState, useEffect } from 'react';
import path from 'ramda/es/path';
import ResizeObserver from 'resize-observer-polyfill';

// DEPRECETED
/**
 *  Хреновина для установления ширин ячеек заголовков у оторванного от таблицы заголовка
 *  Оригинальный заголовок (элемент refFrom) скрывается by prop 'hidden'
 *  Целевой заголовок - refTo. В соответствие приводится ширина дочерних th элементов
 *
 *  Пример:
 *    const [refFrom, refTo, hideOriginHeader] = useColumnsWidthsTo();
 *    ...
 *    <Tr header reference={refTo}>
 *    ...
 *    <Tr header hidden={hideOriginHeader} reference={refFrom}>
 *    ...
 */

export default function () {
  const refFrom = useRef(null);
  const refTo = useRef(null);
  const [success, setSuccess] = useState(false);

  // обработчик на изменении размеров th оригинального заголовка
  // передача размеров
  const handleResize = useCallback((entries) => {
    if (success) return;

    const targetElements = refTo && refTo.current
      ? refTo.current.querySelectorAll('th')
      : null;

    entries.forEach((entry, i) => {
      const styleAlreadySet = !!entry.target.getAttribute('style');
      const { width } = entry.contentRect;
      const thStyle = window.getComputedStyle(entry.target, null);
      const padding = (parseInt(thStyle.getPropertyValue('padding-left'), 10)
        + parseInt(thStyle.getPropertyValue('padding-right'), 10));
      if (styleAlreadySet) { // проверка соответствия реального размера установленному
        const entryCssWidth = parseInt(path(['target', 'style', 'width'], entry), 10);
        if (entryCssWidth === width + padding) return;
      }
      if (targetElements && targetElements[i]) {
        targetElements[i].style.width = `${width + padding}px`;
      }
    });
  }, [refTo, success]);


  // обработчик на изменении размеров th заголовка-копии

  // при наступлении соответствия размеров,
  // установка ширины ячеек оригинального заголовка (чтоб не сдвинулось все при сокрытии)
  // и скрытие оригинального заголовка (через state)
  const handleProof = useCallback((entries) => {
    if (success) return;

    const targetElements = refFrom && refFrom.current
      ? refFrom.current.querySelectorAll('th')
      : null;
    let allEquals = false;

    entries.forEach((entry, i) => {
      if (i === entries.length - 1) {
        if (allEquals && refFrom.current) {
          setSuccess(true);
          entries.forEach((entry_, idx) => {
            const thStyle = window.getComputedStyle(entry_.target, null);
            const width = parseInt(thStyle.getPropertyValue('width'), 10);
            if (targetElements && targetElements[idx]) {
              targetElements[idx].style.width = `${width}px`;
            }
          });
          return;
        }
      }
      const thStyle = window.getComputedStyle(entry.target, null);
      const width = parseInt(thStyle.getPropertyValue('width'), 10);

      if (targetElements && targetElements[i]) {
        const { width: widthTarget } = targetElements[i].getBoundingClientRect();
        const floorWidthTarget = Math.floor(widthTarget);
        allEquals = (i === 0
          ? width === floorWidthTarget
          : allEquals && width === floorWidthTarget);
      }
    });
  }, [success]);

  const ro = useRef(new ResizeObserver(handleResize));
  const roProof = useRef(new ResizeObserver(handleProof));

  const clearFromObserver = useCallback(() => {
    if (ro.current) {
      ro.current.disconnect();
    }
  }, []);

  const clearToObserver = useCallback(() => {
    if (roProof.current) {
      roProof.current.disconnect();
    }
  }, []);

  const refFromFunc = useCallback((node: ?HTMLElement) => {
    clearFromObserver();
    if (node) {
      refFrom.current = node;
      node.querySelectorAll('th').forEach((elTh: HTMLElement) => {
        ro.current.observe(elTh);
      });
      clearToObserver();
      if (refTo.current) {
        refTo.current.querySelectorAll('th').forEach((elTh: HTMLElement) => {
          roProof.current.observe(elTh);
        });
      }
      return;
    }
    setSuccess(false);
  }, [clearFromObserver, clearToObserver]);

  const refToFunc = useCallback((node: ?HTMLElement) => {
    clearToObserver();
    if (node) {
      refTo.current = node;
      node.querySelectorAll('th').forEach((elTh: HTMLElement) => {
        roProof.current.observe(elTh);
      });
      return;
    }
    setSuccess(false);
  }, [clearToObserver]);

  useEffect(() => () => {
    clearFromObserver();
    clearToObserver();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [refFromFunc, refToFunc, success];
}
